let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lN72H")).then(() => parcelRequire('gAGKH'));